export const ON_FILE_PROPERTY_CHANGE_ACTION = 'PROFILE_FORM.ON_FILE_PROPERTY_CHANGE_ACTION';
export const REMOVE_FILE_FROM_LIST_ACTION = 'PROFILE_FORM.REMOVE_FILE_FROM_LIST_ACTION';
export const SAVE_PROFILE_FORMS = 'PROFILE_FORM.SAVE_PROFILE_FORMS';
export const ON_FORM_PROPERTY_CHANGE_ACTION = 'PROFILE_FORM.ON_FORM_PROPERTY_CHANGE_ACTION';
export const SET_SELECTED_IDS_ACTION = 'PROFILE_FORM.SET_SELECTED_IDS_ACTION';
export const SET_SELECTED_FORM_TAB_ACTION = 'PROFILE_FORM.SET_SELECTED_FORM_TAB_ACTION';
export const ADD_NEW_FILES_ACTION = 'PROFILE_FORM.ADD_NEW_FILES_ACTION';
export const PROFILE_FORM_RESPONSE_TRANSACTION = 'PROFILE_FORM.PROFILE_FORM_RESPONSE_TRANSACTION';
export const ON_FOLDER_PROP_CHANGE_ACTION = 'PROFILE_FORM.ON_FOLDER_PROP_CHANGE_ACTION';
